import { PresentationCoverSlideConfigTitleTextSize } from '@/types/schema';

/**
 * Title text size config for the cover/divider/refresh-bundle slide
 * titles. Aligned with the Foundation Figma's Title/Serif ramp (node
 * 15482:12) — each enum bucket maps to a discrete ramp level so the
 * tenant picker stays meaningful and the values stay in lockstep with
 * the rest of the typography system. Medium is the implicit default.
 *
 * Source values from the ramp (font-size / line-height in px):
 *   Small:  32 / 44 — Title/Serif/l
 *   Medium: 36 / 48 — Title/Serif/xl  (also the default)
 *   Large:  48 / 62 — Title/Serif/xxl (matches h1_display under
 *                                       PresentationTypographyProvider)
 */

// Re-export with shorter alias for convenience, matching the
// CoverSlideConfigLogoSize pattern.
export const CoverSlideConfigTitleTextSize =
  PresentationCoverSlideConfigTitleTextSize;
export type CoverSlideConfigTitleTextSize =
  PresentationCoverSlideConfigTitleTextSize;

export const TITLE_TEXT_SIZE_CONFIG: Record<
  CoverSlideConfigTitleTextSize,
  { fontSize: string; lineHeight: string }
> = {
  [CoverSlideConfigTitleTextSize.Small]: {
    fontSize: '2rem', // 32px
    lineHeight: '2.75rem', // 44px
  },
  [CoverSlideConfigTitleTextSize.Medium]: {
    fontSize: '2.25rem', // 36px
    lineHeight: '3rem', // 48px
  },
  [CoverSlideConfigTitleTextSize.Large]: {
    fontSize: '3rem', // 48px
    lineHeight: '3.875rem', // 62px
  },
};
